import { api } from '../axiosClient';
import { UserMeResponse } from './userMe.types';

const USER_ME_PATH = '/User/me';

export const getUserMe = (): Promise<UserMeResponse> => {
  return api.get(USER_ME_PATH);
};
